// src/layouts/Topbar.jsx
import { useEffect, useState } from 'react';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  MoonIcon,
  SunIcon,
  ArrowRightStartOnRectangleIcon,
} from '@heroicons/react/24/outline';
import { getImageUrl } from '@/utils/imageUrl';
import { useNotifications } from '@/hooks/useNotifications';
import NotificationBell from '@/components/common/NotificationBell/NotificationBell';
import styles from './Topbar.module.css';

const Topbar = ({
  title,
  subtitle,
  user,
  onMenuToggle,
  onLogout,
  collapsed = false,
  isDarkMode = false,
  onToggleDarkMode,
}) => {
  const avatarUrl = getImageUrl(user?.avatar_url);
  const [avatarError, setAvatarError] = useState(false);
  const { notifications, totalPending, reload: reloadNotifications } = useNotifications(user?.id);

  // Reset the error flag whenever the avatar URL changes (new user, new upload, etc.)
  useEffect(() => {
    setAvatarError(false);
  }, [avatarUrl]);

  return (
    <header className={styles.topbar}>
      <div className={styles.left}>
        <button
          className={styles.menuBtn}
          onClick={onMenuToggle}
          title={collapsed ? 'Expandir menú' : 'Contraer menú'}
        >
          {collapsed ? <ChevronRightIcon width={24} /> : <ChevronLeftIcon width={24} />}
        </button>
        <div>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
      </div>

      <div className={styles.right}>
        {/* Campana de notificaciones (solo para admin/operador) */}
        {(user?.rol === 'admin' || user?.rol === 'operador') && (
          <NotificationBell
            pendingCount={totalPending}
            notifications={notifications}
            onReload={reloadNotifications}
          />
        )}

        {/* Botón modo oscuro */}
        <button
          className={styles.themeBtn}
          onClick={onToggleDarkMode}
          title={isDarkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
        >
          {isDarkMode ? <SunIcon width={20} /> : <MoonIcon width={20} />}
        </button>

        <div className={styles.divider} />

        {/* Perfil de usuario */}
        <div className={styles.userProfile}>
          <div className={styles.avatarSmall}>
            {avatarUrl && !avatarError ? (
              <img
                src={avatarUrl}
                alt="Avatar"
                onError={() => setAvatarError(true)}
              />
            ) : (
              user?.nombre?.[0]?.toUpperCase()
            )}
          </div>
          <div className={styles.userText}>
            <span className={styles.userName}>{user?.nombre?.split(' ')[0]}</span>
            <span className={styles.userRole}>{user?.rol}</span>
          </div>
        </div>

        {/* Botón de salir */}
        <button className={styles.logoutBtn} onClick={onLogout} title="Cerrar sesión">
          <ArrowRightStartOnRectangleIcon width={16} />
          <span>Salir</span>
        </button>
      </div>
    </header>
  );
};

export default Topbar;